/**
 * ConfirmPasswordModal.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import axios from 'axios';
import * as Icons from '../../../sharedComponents/icons/Icons';

import ConfirmPasswordForm from './ConfirmPasswordForm';
import ConfirmPasswordConfirmation from './ConfirmPasswordConfirmation';

const propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    confirmType: PropTypes.string,
    confirmToken: PropTypes.string
};

const defaultProps = {
    isOpen: false,
    closeModal: () => {},
    confirmType: "Account",
    confirmToken: ""
};

export default class ConfirmPasswordModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password1: '',
            password2: '',
            passwordError: false,
            serverError: false,
            completed: false
        };

        this.getConfirmationLabel = this.getConfirmationLabel.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.confirmToken = this.confirmToken.bind(this);
        this.confirmPasswords = this.confirmPasswords.bind(this);
    }

    getConfirmationLabel() {
        if (this.props.confirmType === "Account") {
            return "Set Password";
        }
        if (this.props.confirmType === "Reset") {
            return "Reset Password";
        }
        return "";
    }

    afterOpenModal() {
        this.setState({
            password1: '',
            password2: '',
            passwordError: false,
            serverError: false,
            completed: false
        });
    }

    confirmToken() {
        if (this.state.password1 !== this.state.password2 || this.state.password1.length < 8 || this.state.password1.length > 64) {
            this.setState({
                passwordError: true,
                serverError: false
            });
        }
        else {
            const url = `${process.env.API}/accounts/registration/${this.props.confirmToken}`;

            axios.post(url, {
                password: this.state.password2
            })
                .then(() => {
                    this.setState({
                        passwordError: false,
                        serverError: false,
                        completed: true
                    });
                })
                .catch(() => {
                    this.setState({
                        passwordError: false,
                        serverError: true
                    });
                });
        }
    }

    confirmPasswords(account) {
        this.setState({
            password1: account.password1,
            password2: account.password2
        }, () => {
            this.confirmToken();
        });
    }

    render() {
        let errorText = null;
        if (this.state.passwordError) {
            errorText = "You need to strike a match! These passwords either don't match or don’t meet our criteria. Passwords must have 8 characters including a capital letter, lower case letter, special character, and number. Please try again. ";
        }
        if (this.state.serverError) {
            errorText = 'An error has occurred, please try again later.';
        }

        let confirmationMessage = null;
        if (this.props.confirmType === "Account") {
            confirmationMessage = "Your Account was successfully created.";
        }
        else {
            confirmationMessage = "Your password was successfully reset.";
        }

        let content = null;

        if (this.state.completed) {
            content = (
                <ConfirmPasswordConfirmation
                    label={this.getConfirmationLabel()}
                    message={confirmationMessage}
                    email={this.state.email}
                    closeModal={this.props.closeModal} />
            );
        }
        else {
            content = (
                <ConfirmPasswordForm
                    errorText={errorText}
                    label={this.getConfirmationLabel()}
                    confirmPasswords={this.confirmPasswords} />
            );
        }

        return (
            <Modal
                ref={(modal) => this.modal = modal}
                role="complementary"
                isOpen={this.props.isOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.props.closeModal}
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md rec-acct-modal rec-acct-confirm-modal',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open',
                    beforeClose: 'rec-overlay-before-close'
                }}
                contentLabel="Confirm Password"
                ariaHideApp={false}>
                <div className="rec-modal-content-wrap">
                    <button className="rec-close-modal" onClick={this.props.closeModal}>
                        <Icons.IconClose />
                    </button>
                    {content}
                </div>
            </Modal>
        );
    }
}

ConfirmPasswordModal.propTypes = propTypes;
ConfirmPasswordModal.defaultProps = defaultProps;
